/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agents_Revoke_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Revoke \"{name}\"? The relay's API key will stop working immediately and the WebSocket session will be terminated." |
*
* @param {Agents_Revoke_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_revoke_confirm_description = /** @type {((inputs: Agents_Revoke_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Revoke_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" widerrufen? Der API-Schlüssel wird sofort ungültig und die WebSocket-Verbindung wird beendet.`)
	return /** @type {LocalizedString} */ (`Revoke "${i?.name}"? The relay's API key will stop working immediately and the WebSocket session will be terminated.`)
});